(() => {
  const mediaQuery = window.matchMedia('(max-width: 749px)');

  const drawerDetails = () => document.getElementById('Details-menu-drawer-container');
  const header = () => document.getElementById('header-component');

  const setDrawerOffset = () => {
    const details = drawerDetails();
    const headerEl = header();
    if (!details || !headerEl || !mediaQuery.matches) return;

    const rect = headerEl.getBoundingClientRect();
    const top = Math.max(0, Math.round(rect.bottom));
    details.style.setProperty('--dc-mobile-drawer-top', `${top}px`);
  };

  const resetNestedMenus = () => {
    const details = drawerDetails();
    if (!details) return;

    const drawer = details.querySelector('.menu-drawer');
    drawer?.classList.remove('menu-drawer--has-submenu-opened');

    details.querySelectorAll('details[open]:not(#Details-menu-drawer-container)').forEach((nested) => {
      nested.classList.remove('menu-open');
      nested.removeAttribute('open');
      nested.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  };

  const bind = () => {
    const details = drawerDetails();
    if (!details || details.dataset.dcMobileHeaderBound === 'true') return;

    details.dataset.dcMobileHeaderBound = 'true';
    details.addEventListener('toggle', () => {
      if (details.open) {
        setDrawerOffset();
        window.requestAnimationFrame(setDrawerOffset);
      } else {
        resetNestedMenus();
      }
    });
  };

  const setup = () => {
    bind();
    setDrawerOffset();
  };

  window.addEventListener('resize', setDrawerOffset, { passive: true });
  window.addEventListener('orientationchange', setDrawerOffset);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
